<template>
  <div class="consultTeacher">
      <div class="consultTeacherMain">
          <div class="header">
              <span>商品列表</span>
          </div>
          <div class="TeacherList">
              <div class="teacherCell" v-for="item of goodsList" :key="item.id" >
                  <div style="width:110px">
                    <img :src="item.cover" class="cover"/>
                  </div>  
                  <div class="goods-content">
                    <div class="goods-title">{{item.name}}</div>
                    <div class="goods-price">
                      <span class="money-symbol">￥</span>
                      <span class="money-num">{{item.price}}</span>
                    </div>
                  </div>
                  <div class="right">
                    <div class="to-buy" :class="{ 'disabled': item.count == 0 && item.infinite == 0 }"  @click="toDetail(item)">去抢购</div>
                    <div class="num" v-if="item.infinite !== 1">库存: {{ item.count }}</div>
                  </div>
              </div>
          </div>
          <img class="closeBtn" @click="closeBtnClicked" src="https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png">
      </div>
  </div>
</template>

<script>

import tool from '../../../../kits/Tools';
import qs from 'qs';
import axios from 'axios'
import { Notify } from 'vant';

export default {
  props: {
      dsId: {
          type: Number | String,
          default: 0
      },
      fansId: {
          type: Number | String,
          default: 0
      },
      tid: {
          type: Number | String,
          default: 0
      },
      uid: {
          type: Number | String,
          default: 0
      },
      gid: {
          type: Number | String,
          default: 0
      },
      channel_id: {
        type: String | Number,
        default: 0
      },
      goodsIds: {
        type: Array | Object,
        default: () => []
      }
  },
  data(){
      return{
          teacherList:[],
          timer:null,
          showType: 1,
          selectItem: null,
          messageList: [],
          comment:'',
          username:'',
          tel:'',
          goodsNum:1,
          goodsList:[]
      }
  },
  watch:{
      // dsId (to) {
      //     if (to) {
              
      //         this.startTimeList()
      //     }
      // },
      showType (to) {
         this.switchTimeList();
      },
       
  },
  mounted(){
    console.log('gid--------------',this.gid)
  },
  methods:{
      preview(url) {
          wx.previewImage({
          current: url, // 当前显示图片的http链接
          urls: [url], // 需要预览的图片http链接列表
          });
      },
      switchTimeList(){
          if (this.showType === 1) {
              this.startTimeList()
          }else {
              this.stopTimeList();
          }
      },
      stopTimeList(){
          clearInterval(this.timer);
          this.timer = null;
      },
      closeBtnClicked(){
          this.stopTimeList();
          this.$emit("closeBtnClicked");
      },
      getTeacherList () {
          const param = {
              ds_id: this.dsId
          }
          if (this.tid) {
              param.tid = this.tid
          }
          let self = this
          this.axios.post(tool.baseUrlUser() + '/app/index/getOnlineTeacherList',
              qs.stringify(param)
              )
              .then(function (data) {
              if (data.data.code === 2000) {
                  const tList = [];
                  data.data.data.list.forEach(element => {
                  const item = self.teacherList.find((item)=>{ return item.fans_id == element.fans_id})
                      element.unRead = item && item.unRead ? item.unRead : 0;
                      tList.push(element);
                  });
                  self.teacherList = tList;
              }
              })
              .catch(function (data) {})
      },
      toDetail ({id, count, infinite, jump, payurl}) {
        if(jump === 1) {
          window.open(payurl)
          return
        }
        if(count == 0 && infinite == 0) {
          Notify('商品库存不足')
          return
        }
        if(tool.isWeixinMP()){ //小程序内打开
          const appid = localStorage.getItem("current_app_Id");
          const fans =  JSON.parse(localStorage.getItem(appid))
          let data = {
            gid:id,
            uid:this.uid,
            header:fans.header,
            nick:fans.nick,
            openid:fans.openid,
            fansid:fans.fans_id,
            ds_id: this.dsId,
            channel_id: this.channel_id
         }
         let option = ''
          for(var i in data) {
              if(data[i]){
                option = option + `${i}=${data[i]}&`
              }
          }
           option =option.slice(0,option.length-1);
           wx.miniProgram.navigateTo({url:`/pages/goods/goods?${option}`})  
        }else if(tool.isWeixin()){
          this.$router.push({path:`/goodsDetail?id=${id}&uid=${this.uid}&channel_id=${this.channel_id}&dsId=${this.dsId}`})
        }else{
          Notify('请在微信内打开')
        }   
      },
      startTimeList () {
          this.getTeacherList();
          if (this.timer) {
              clearInterval(this.timer)
              this.timer = null
          }
          this.timer = setInterval(() => {
              this.getTeacherList()
          }, 10000)
      },
      async getGoodsList(){
        // const current_app_Id = window.localStorage.getItem("current_app_Id");
        // const fans = JSON.parse(window.localStorage.getItem(current_app_Id));
        // const token = fans.token;
        // const option = "ds_id="+ this.dsId 
        const ids = JSON.stringify(this.goodsIds)
        const option = `ds_id=${this.dsId}&goods_id=${ids}`
        try{
          const res =  await axios.post(tool.baseUrl2()+'/goods/list',option)
          // const res =  await axios.post('http://liveapi2.tenghuiwangxiao.com/api/goods/list',option)
          console.log(res)
          if(res.data.code === 200){
            this.goodsList = res.data.data.list
            this.goodsList.forEach(item => {
              this.getGoodsNum(item.id)
            })
          }
        }catch(error){
          console.log(error)
        }
      },
      async getGoodsNum(id) {
        // const option = `ds_id=209972&goods_id=27`
        // const { data: { code, data } } =  await axios.post('http://liveapi2.tenghuiwangxiao.com/api/goods/goodsInventory',option)
        const option = `ds_id=${this.dsId}&goods_id=${id}`
        const { data: { code, data } } =  await axios.post(tool.baseUrl2()+'/goods/goodsInventory',option)
        if(code === 200) {
          this.goodsList = this.goodsList.map(item => {
            if(item.id == data.goods_id) {
              item.count = data.count
              item.infinite = data.infinite
            }
            return item
          })
        }
      }
  }
}
</script>

<style lang="less" scoped>

.consultTeacher{
  width: 100%;
  height: 500px;
  position:fixed;
  bottom: 0px;
  left: 0px;
  z-index: 5000;
}

.consultTeacher .consultTeacherMain{
  position:relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
  height: 100%;
  background-color: white;
}

.consultTeacher .messageMain{
  position:relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
  height: 100%;
  background-color: white;
}

.messageMain .header{
  height: 40px;
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
}

.messageMain .header .back{
  width: 20px;
  margin-left: 15px;
  vertical-align: -5px;
}

.messageMain .header span{
  line-height: 40px;
}

.consultTeacherMain .header{
  height: 40px;
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
}

.consultTeacherMain .header span{
  line-height: 40px;
  margin-left: 20px;
}

.closeBtn{
  width: 20px;
  height: 20px;
  position:absolute;
  right: 10px;
  top: 10px;
}

.consultTeacher .consultTeacherMain .TeacherList{
  width: 100%;
  height: 459px;
  overflow: auto;
  box-sizing: border-box;
  padding: 16px;
}

.consultTeacherMain .TeacherList .teacherCell{
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.consultTeacherMain .TeacherList .teacherCell .goods-num{
  width: 30px;
}
.consultTeacherMain .TeacherList .teacherCell.order{
  padding-bottom: 25px;
  border-bottom: 1px #eee solid;
}
.consultTeacherMain .TeacherList .teacherCell .goods-content{
  margin-left: 10px;
  width: 170px;
}
.consultTeacherMain .TeacherList .teacherCell .goods-content .goods-title{
  font-weight: 700px;
  font-size: 14px;
  line-height: 20px;
  font-size: #101010;
  width: 170px;
  height: 40px;
  font-weight: 700;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal !important;
  word-wrap: break-word; 
}

.consultTeacherMain .TeacherList .teacherCell .goods-price{
  display: flex;
  color: #F34718;
  font-weight: 700;
  align-items: center;
}
.consultTeacherMain .TeacherList .teacherCell .goods-price .stepper{
  margin-left: auto;
  font-weight: 400;
}
.consultTeacherMain .TeacherList .teacherCell .money-symbol{
  font-size: 12px;
}
.consultTeacherMain .TeacherList .teacherCell .money-num{
  font-size: 18px;
}
.consultTeacherMain .TeacherList .teacherCell .right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 63px;
}
.consultTeacherMain .TeacherList .teacherCell .right .num {
  font-size: 12px;
}

.consultTeacherMain .TeacherList .teacherCell .to-buy{
  width: 60px;
  height: 25px;
  color: #f5f5f5;
  text-align: center;
  line-height: 25px;
  background: linear-gradient(315deg,#ED3F10,#FB724D);
  border-radius: 4px;
  margin-left: auto;
}

.consultTeacherMain .TeacherList .teacherCell .to-buy.disabled{
  background: #dddddd;
}

.consultTeacherMain .TeacherList .teacherCell .cover{
  height: 72px;
  width: 110px;
  border-radius: 4px;
}
.consultTeacherMain .TeacherList .form{
  outline: none;
  position: relative;
  
}
.consultTeacherMain .TeacherList i{
  position: absolute;
  font-style: normal;
  left: -8px;
  top: 4px;
}
.consultTeacherMain .footer{
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  padding: 0 10px;
  height: 50px;
  box-sizing: border-box;
  align-items: center;
}
.consultTeacherMain .footer .sum-text{
  margin-right: 4px;
}
.consultTeacherMain .footer .sum-money{
  color: #F34718;
  font-weight: 700;
}
.consultTeacherMain .footer .sum-money span:first-child{
  font-size: 14px;
  margin-right: 2px;
}
.consultTeacherMain .footer .sum-money span:last-child{
  font-size: 22px;
}
.consultTeacherMain .footer .comfirm-btn{
  margin-left: auto;
}
.consultTeacherMain .footer .comfirm-btn button{
  border: none;
  color: #FFFFFF;
  width: 100px;
  height: 36px;
  border-radius: 20px;
  background: #0084ff;
}
.messageBox{
overflow-x: hidden;
height: 219px;
}

.messageCell{
margin-top: 5px;
margin-bottom: 5px;
}

.messageCell .messageHeader{
height: 40px;
position:relative;
}

.messageHeader .time{
font-size: 12px;
position: absolute;
top: 8px;
right: 20px;
}

.messageHeader .name{
font-size: 14px;
position: absolute;
top: 2px;
left: 42px;
}

.messageCell .messageHeader img{
height: 30px;
position: absolute;
width: 30px;
border-radius: 15px;
}

.messageCell .other{
top: 5px;
left: 10px;
}


.messageCell .content{
padding-left: 48px;
word-wrap:break-word;
word-break:normal;
padding-right: 20px;
white-space: pre-line;
}

.inputBox{
  width: 100%;
  height: 40px;
}

.inputBox .inputField{
  float: left;
  background-color: #FFFFFF;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-left: 5px;
  margin-left: 10px;
  margin-right: 10px;
  border: solid 1px #F5F5F5; 
  border-radius: 10px;
  width: 70%;
  margin-top: 2px;
}
.inputBox .sendBtn{
  float: left;
  width: 20%;
  margin-top: 5px;
}

.contentImg{
  max-width: 45%;
  padding: 10px;
  padding-left: 48px;
}


</style>


// WEBPACK FOOTER //
// index.vue?a18c96a2